// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".778acd4f4d9ed39565467fd5072684518fcadf4b.chunk.js";
};